export class WorkOrderPackagingCreateConfiguration{


  constructor (public ParentLocationOid : number | null,public WorkOrderOid: number | null){}

  public static create = (parentLocationOid : number | null, workOrderOid : number | null) : WorkOrderPackagingCreateConfiguration => new WorkOrderPackagingCreateConfiguration(parentLocationOid,workOrderOid);


}
